import Vue from 'vue'
import App from './App.vue'
import router from './router'

import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import AOS from 'aos'
import 'aos/dist/aos.css'
import AnimateCSS from 'animate.css'
import Multiselect from 'vue-multiselect'
import LoadScript from 'vue-plugin-load-script';
import vuescroll from 'vuescroll';
import VueLazyload from 'vue-lazyload'


import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import i18n from './i18n'

Vue.use(AnimateCSS);
Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.component('multiselect', Multiselect)
Vue.use(LoadScript)
Vue.use(vuescroll);
Vue.use(VueLazyload, {
  observer:false,
  loading: require('./assets/img/Loader.gif')
})

Vue.config.productionTip = false

new Vue({
  router,
  i18n,
  created () {
    AOS.init()
  },
  render: h => h(App)
}).$mount('#app')
